import type { FC } from 'react'
import { Alert } from '@dhl-ui/components'
import { type Address, AddressLines } from '@dhl/components'

type Props = {
  address: Address

  hasExtraAddressLine?: boolean
}

export const AddressPreviewComponent: FC<Props> = ({ address, hasExtraAddressLine }) => (
  <Alert severity="success" variant="standard" data-testid="addressLine">
    <AddressLines
      address={address}
      showExtraAddressLine={
        hasExtraAddressLine && !!address.additionalAddressLine && address.additionalAddressLine?.length > 0
      }
    />
  </Alert>
)
